;$(function () {
  'use strict'

  const buttonsRowSelector = '[data-buttons-row]'
  const buttonRowActiveSelector = '[data-button-row-active]'
  const $buttonsRow = $(buttonsRowSelector)
  const $buttonsRowActive = $(buttonRowActiveSelector)
  if ($buttonsRow.length && $buttonsRowActive.length) {
    var visibleArea = $buttonsRow.width()
    var activeButtonSize = $buttonsRowActive.width()
    var activeButtonPosition = $buttonsRowActive.offset().left
    var activeButtonVisibility = activeButtonPosition + activeButtonSize
    var animationDuration = 200

    if (activeButtonVisibility > visibleArea) {
      $(buttonsRowSelector).animate({
        scrollLeft: '+=' + activeButtonPosition + 'px'
      }, animationDuration)
    }
  }
})
